module.exports = __webpack_public_path__ + "static/media/Manual M4 WiLink 5.4b98e81d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual M4 WiLink 5.pdf
// module id = 906
// module chunks = 0